__turbopack_context__.v({
  "root": "LabelledCheckbox-module__36IWGG__root",
});
